<script>
    import { createEventDispatcher } from 'svelte';
    import { Authentication } from '../stores'
    
    const dispatch = createEventDispatcher();

    let modalStep = 0;
    export let customer = {id: 0, firstName: '', lastName: '', address: '', phone: '', mobile: '', email: '', remark: ''};
    let value;
    let shown = false;
    let authenthicationData = '';

    export function show() {
        modalStep = 0;
        shown = true;
    }
    function hide() {
        shown = false;
    }

    let onChange = () => {};
    
    async function _onOkay() {
        await Authentication.subscribe((data) => authenthicationData = data);

        let method = 'POST';
        if(customer.id != 0) {
            method = 'PUT';
        }

        const response = await fetch(
            'MYURL/customer',
            {
                method: method,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
                body: JSON.stringify(
                    customer
                )
            }
        );
        const data = await response.json();

        dispatch('accepted', {
            
        });

        _onCancel();
    }
    
    function _onNextClick() {
        modalStep += 1;
    }
    
    function _onCancel() {
        customer = {id: '', firstName: '', lastName: '', address: '', phone: '', mobile: '', email: '', remark: ''};
        hide();
    }
    
    $: onChange(value)
</script>

<svelte:window on:keydown={(e) => {
    if(e.keyCode == 27) {
        hide();
    }
}} />
{#if shown}
    <div class="cruCustomer">
        <div class="modal">
            <span class="close" on:click={() => hide()}>&times</span>
            {#if customer.id === 0}
                <h2>Neuer Kunde</h2>
            {:else}
                <h2>Kunde bearbeiten</h2>
            {/if}
            
            {#if modalStep === 0}
            <h3>Vorname</h3>
            <input class="textbox" bind:value={customer.firstName} />
            <h3>Nachname</h3>
            <input class="textbox" bind:value={customer.lastName} />
            <h3>Adresse</h3>
            <textarea class="textboxMultiLine" bind:value={customer.address} />
            {/if}
            {#if modalStep === 1}
            <h3>Telefon</h3>
            <input class="textbox" bind:value={customer.phone} />
            <h3>Handy</h3>
            <input class="textbox" bind:value={customer.mobile} />
            <h3>E-Mail</h3>
            <input class="textbox" bind:value={customer.email} />
            <h3>Bemerkung</h3>
            <textarea class="textboxMultiLine" bind:value={customer.remark} />
            {/if}
            
            <div>
                <div class="buttons">
                    {#if modalStep < 1}
                        <button on:click={() => _onNextClick()}>
                            Weiter
                        </button>
                    {:else}
                        <button on:click={() => _onOkay()}>
                            Speichern
                        </button>
                    {/if}

                    <button on:click={_onCancel}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}


<style>
    .textbox {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
    }
    .textboxMultiLine {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
        min-height: 70px;
    }

    .buttons {
        float: right;
    }

	.cruCustomer {
	  background: rgb(0, 0, 0);
	  background: rgba(0, 0, 0, 0.6);
      position: fixed;
      width: 88%;
      height: 100%;
      top: 0;
      left: 0;

	  padding: 3rem 7.5rem;
	  display: flex;
	  flex-direction: column;
	}

    .modal {
        background-color: white;
        max-width: 80vw;
        padding: 1em;
        margin: -30px auto;
    }

    .close {
        cursor: pointer;
        float: right;
    }
    .close:hover {
        font-weight: bold;
    }
  
    @media only screen and (max-width: 767px) {
      .cruCustomer {
          background: rgb(0, 0, 0);
          background: rgba(0, 0, 0, 0.6);
          position: fixed;
          width: 98%;
          height: 100%;
          top: 0;
          left: 0;
          overflow-y: scroll;
          padding: 3rem 1%;
          flex-direction: column;
      }
      
      .textbox {
          padding-top: -10px;
          margin-top: -10px;
          min-width: 320px;
      }
      
      .textboxMultiLine {
          padding-top: -10px;
          margin-top: -10px;
          min-width: 320px;
          min-height: 100px;
      }
  }
</style>